import { render, staticRenderFns } from "./indexSidebar.vue?vue&type=template&id=2151bcf4&"
import script from "./indexSidebar.vue?vue&type=script&lang=js&"
export * from "./indexSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports